<template>
  <v-card>
    <v-card-title class="primary accent--text">
      {{ title }}
    </v-card-title>

    <v-card-text>
      <v-row v-if="isLoading">
        <v-col cols="12">
          <v-row
            align="center"
            justify="center"
          >
            <v-progress-circular
              :size="125"
              :width="7"
              color="primary"
              indeterminate
            />
          </v-row>
        </v-col>
      </v-row>

      <v-row v-if="hasCustomer && !isLoading">
        <v-col cols="12">
          <info-list
            :list="infoList()"
          />
        </v-col>
      </v-row>

      <v-row v-if="!hasCustomer && !isLoading">
        <v-col cols="12">
          <v-row
            align="center"
            justify="center"
          >
            <v-icon>person</v-icon>
          </v-row>
        </v-col>

        <v-col cols="12">
          <v-row
            align="center"
            justify="center"
          >
            <span>Select a customer to begin creating a subscription.</span>
          </v-row>
        </v-col>

        <v-col cols="12">
          <v-row
            align="center"
            justify="center"
          >
            <v-btn>
              <v-icon left>
                add
              </v-icon>

              Select a customer
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex'
import { get, isEmpty } from 'lodash'
import InfoList from "../Common/InfoList"

export default {
  components: { InfoList },
  props: {
    initCustomer: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isLoading: false,
      customer: null,
    }
  },
  computed: {
    hasCustomer() {
      return !isEmpty(this.customer)
    },
    title() {
      return this.hasCustomer
        ? 'has'
        : 'Customer'
    }
  },
  watch: {
    initCustomer() {
      this.customer = this.initCustomer
    }
  },
  async mounted() {
    const id = this.$route.query.customer

    if (id) {
      await this.loadCustomer(id)
    }
  },
  methods: {
    ...mapActions([ 'getCustomer' ]),
    async loadCustomer(id) {
      const payload = { id }

      this.isLoading = true
      const customer = await this.getCustomer(payload)
        .finally(() => {
          this.isLoading = false
        })

      this.customer = customer || null
      this.$emit('customer-loaded', { ...this.customer })
    },
    infoList() {
      return [
        {
          label: 'Name',
          value: this.customer.name
        },
        {
          label: 'Email',
          value: this.customer.email
        },
        {
          label: 'Phone',
          value: this.customer.phone
        },

        {
          label: 'Address',
          value: [
            get(this.customer, 'address.line1'),
            get(this.customer, 'address.line2'),
            `${get(this.customer, 'address.city')}, ${get(this.customer, 'address.state', '')} ${get(this.customer, 'address.postal_code', '')}`,
            get(this.customer, 'country'),
          ]
        },
        {
          label: 'Tax Status',
          value: this.customer.tax_exempt
        },
        {
          label: 'Currency',
          value: this.customer.currency
        },
      ]
    }
  },

}
</script>
